import React, { useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { addDepartment } from "../superAdminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { validateIsLettersAndDigitsSpaceOnly } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from '../../../store/slices/snackbarSlice';
const AddDepartment = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [departmentName, setDepartmentName] = useState<string>("");
  const onChangeDepartment = (value: string) => {
    if (validateIsLettersAndDigitsSpaceOnly(value)) {
      setDepartmentName(value);
    }
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      name: departmentName,
    };
    dispatch(
      addDepartment({
        params: postData,
        callback: (res: any) => {
          setDepartmentName("");
          dispatch(showSnackbar({ message: "Department added Successfully", type: res?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: (err: any) => {
          dispatch(showSnackbar({ message: err?.data?.msg, type: err?.data?.status }))
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    return departmentName === ""
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Add Department"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4">
          <form onSubmit={handleSubmit}>
            <div className="row align-items-center">
              <div className="col-md-6">
                <LabelInput labelName={"Department Name"} />
                <div className="d-flex align-items-center my-3">
                  <div className="me-3 col-md-8">
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter Department Name"}
                      setInputText={(value: any) => onChangeDepartment(value)}
                      value={departmentName}
                    />
                  </div>
                  <div className="col-md-2">
                    <Submitbtn name={"Add"} disabled={validations()} />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddDepartment;
